export default __webpack_public_path__ + "static/media/invoice_6.9ed02b54.PNG";